import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Card, CardContent, Typography, Stack, Chip } from '@mui/material';
import { getBearerToken, postBearerToken, putBearerToken } from '../../utils/Apis';
import { useNavigate } from 'react-router-dom';
import AppShell from '../../layouts/AppShell';

const A_active_user_list = () => {
    const navigate = useNavigate()
    const [rows, setrows] = React.useState([])
    const [rendered, setrendered] = useState(0)

    React.useEffect(() => {
        const intervalId = setInterval(() => {
            fetch_users()
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [rendered])


    const editAdmin = async (id, type) => {
        if (type == "E") {
            navigate("/edit_sub_admin", { state: { id: id } })
        } else {
            let current_date = new Date();
            putBearerToken("users?_id=" + id, {
                deleted_at: current_date,
                slug_name: current_date + id,
                client_id: current_date + id,
                client_secret: current_date + id,
                oauth_id: current_date + id,
                s2s_client_id: current_date + id,
                s2s_client_secret: current_date + id,
            }).then((result) => {
                if (result.error == 0) {

                    setrendered(o => o + 1)

                } else {


                }

            })

        }

    }

    const fetch_users = async () => {
        let pathname = window.location.pathname
        let room_id = pathname.split("/")[2]
        getBearerToken("fetch_active_users_of_room?room=" + room_id).then((result) => {
            if (result.error == 0) {
                console.log(result.data)
                setrows(result.data)
            } else {
                // notify(JSON.stringify(result.messages))
            }
        })
    }


    const columns = [
        {
            field: 'first_name',
            headerName: 'First Name',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'phone',
            headerName: 'Phone',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'slug_name',
            headerName: 'User Name',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'type',
            headerName: 'Type',
            flex: 1,
            minWidth: 100,
            valueGetter: (params) => params.row.type == "SubAdmin" ? "Host" : "User"

        },
        {
            field: 'mute_status',
            headerName: 'Mute Status',
            flex: 1,
            minWidth: 130,
            renderCell: (params) => (
                <Chip size="small"
                    color={params.row.mute_status == true ? "success" : "error"}
                    variant="outlined"
                    label={params.row.mute_status == true ? "Mute" : "Unmute"} />
            )
        },


    ];


    return (
        <AppShell title="Active Users" breadcrumb={['Rooms', 'Active Users']}>
            <Card>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">Active Users</Typography>
                    </Stack>

                    <Box sx={{ width: '100%' }}>
                        <DataGrid
                            autoHeight
                            rows={rows}
                            columns={columns}
                            getRowId={(data) => data._id}
                            disableRowSelectionOnClick
                            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                            pageSizeOptions={[10, 25, 50]}
                            sx={{ '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' } }}
                        />
                    </Box>
                </CardContent>
            </Card>
        </AppShell>
    )
}

export default A_active_user_list
